import * as Sentry from "@sentry/vue";
import type { UseMutationOptions } from "@tanstack/vue-query";
import { useMutation } from "@tanstack/vue-query";
import type { StoredFileUpload } from "@/components/MyStudents/Submissions/types";
import { createUUIDName, s3Upload } from "@/util/s3";

export interface UploadCommentFileVariables {
  file: File;
  originalName: string;
  size: number;
}

export const useUploadCommentFile = (
  useMutationOptions?: UseMutationOptions<StoredFileUpload, Error, UploadCommentFileVariables>,
) =>
  useMutation<StoredFileUpload, Error, UploadCommentFileVariables>({
    mutationFn: async ({ file, originalName, size }) => {
      const newName = createUUIDName(file.name);
      const s3 = await s3Upload(file, newName);
      return {
        storage: "s3",
        file_name: newName,
        bucket: s3.Bucket,
        key: s3.key,
        file_path_url: s3.Location,
        acl: "private",
        size,
        type: file.type,
        original_file_name: originalName,
      };
    },
    onError: (uploadError) => {
      Sentry.captureException(uploadError, {
        tags: { fieldName: "todo_comment", troubleshooting_note: `S3 upload: ${uploadError}` },
      });
    },
    ...useMutationOptions,
  });
